<template>
    <section class="kws-quiz-registration" v-bind="parseAttributeString">
      <div class="kws-quiz-text-wrapper">
        <h2 class="h2" v-html="headlineText"></h2>
        <first-spirit-image
          v-if="img && img.sm"
          class="kws-quiz-img-mobile"
          :fs-cc-attrs="img.fsCcAttrs"
          :alt="img.alt"
          :src="img.sm.src"
          :srcset="img.sm.srcset"
          :sizes="img.sm.sizes"
        ></first-spirit-image>
        <div class="kws-quiz-text-content">
          <div class="error-box mb-3" v-if="error">
            <h4 class="h4" v-text="errorText"></h4>
          </div>
          <p class="" v-if="result && result.registration">{{ resultText }}</p>
          <p class="">{{ text }}</p>

          <div class="form-component__container form-component__container--row">
            <div class="form-component">
              <div class="form-component__content">
                <div class="form-component__content--form">
                  <div class="row mb-3">
                    <div class="col-12 col-m-6 mb-s-3 mb-m-0">
                      <dropdown
                        :id="formData.salutation.id"
                        :label="formData.salutation.label"
                        :options="formData.salutation.options"
                        :mandatory="formData.salutation.mandatory"
                        v-model="formData.salutation.value"
                      ></dropdown>
                    </div>
                    <div class="col-12 col-m-6">
                      <dropdown
                        :id="formData.title.id"
                        :label="formData.title.label"
                        :options="formData.title.options"
                        :mandatory="formData.title.mandatory"
                        v-model="formData.title.value"
                      ></dropdown>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-m-6 mb-s-3 mb-m-0">
                      <textfield
                        :id="formData.firstName.id"
                        :label="formData.firstName.label"
                        :mandatory="formData.firstName.mandatory"
                        v-model="formData.firstName.value"
                      ></textfield>
                    </div>
                    <div class="col-12 col-m-6">
                      <textfield
                        :id="formData.lastName.id"
                        :label="formData.lastName.label"
                        :mandatory="formData.lastName.mandatory"
                        v-model="formData.lastName.value"
                      ></textfield>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12">
                      <textfield
                        :id="formData.company.id"
                        :label="formData.company.label"
                        :mandatory="formData.company.mandatory"
                        v-model="formData.company.value"
                      ></textfield>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12">
                      <textfield
                        :id="formData.street.id"
                        :label="formData.street.label"
                        :mandatory="formData.street.mandatory"
                        v-model="formData.street.value"
                      ></textfield>
                    </div>
                  </div>
                  <postal-code-place
                    :postal-code-pattern="formData.postalCodePlace.postalCodePattern"
                    :postal-code-value="postalCodeUser"
                    :city-value="cityUser"
                    :country-code="formData.postalCodePlace.countryCode"
                    :api-url="formData.postalCodePlace.apiUrl"
                    :mandatory="formData.postalCodePlace.mandatory"
                    :wrapper="PostalCodePlaceWrapper"
                    @change="setPostalCodeAndCityValue"
                  ></postal-code-place>
                  <div class="row mb-3">
                    <div class="col-12 col-m-6 mb-s-3 mb-m-0">
                      <textfield
                        :id="formData.district.id"
                        :label="formData.district.label"
                        :mandatory="formData.district.mandatory"
                        v-model="formData.district.value"
                      ></textfield>
                    </div>
                  </div>
                  <div class="row mb-3">
                  <div class="col-12 col-m-6">
                      <textfield
                        :id="formData.email.id"
                        :label="formData.email.label"
                        :mandatory="formData.email.mandatory"
                        v-model="formData.email.value"
                      ></textfield>
                    </div>
                    <div class="col-12 col-m-6 mb-s-3 mb-m-0" v-if="result && result.registration">
                      <passwordfield
                        :id="formData.password.id"
                        :label="formData.password.label"
                        :mandatory="formData.password.mandatory"
                        v-model="formData.password.value"
                      ></passwordfield>
                    </div>
                  </div>
                </div>
              </div>
              <div class="required-info-field">{{ translate('lblMandatory') }}</div>
              <div class="accept-terms">
                <input
                  id="accept-terms"
                  type="checkbox"
                  value="true"
                  required
                  v-model="formData.acceptTerms.value"
                >
                <label for="accept-terms" v-html="formData.acceptTerms.label"></label>
              </div>
            </div>
          </div>

          <button
            class="button button--medium button--back"
            v-if="result && !result.registration"
            @click="goBack"
          >{{ translate('btnBack') }}</button>
          <button
            class="button button--medium button--primary"
            :disabled="!continueAllowed"
            @click="handIn"
          >
            {{ translate('btnSubmit') }}
          </button>
        </div>
      </div>
      <div class="kws-quiz-img-desktop">
        <first-spirit-image
          v-if="img && img.lg"
          class="kws-quiz-img-desktop"
          :fs-cc-attrs="img.fsCcAttrs"
          :alt="img.alt"
          :src="img.lg.src"
          :srcset="img.lg.srcset"
          :sizes="img.lg.sizes"
        ></first-spirit-image>
      </div>
    </section>
</template>

<style lang="scss">
.kws-quiz-registration {
  background-color: rgba(255, 255, 255, .75);
  color: $color-black;

  .accept-terms {
    padding-top: rem(20px);
    padding-bottom: rem(20px);

    label {
      display: block;
      padding-inline-start: rem(32px);
      position: relative;

      p {
        font-size: inherit;
        font-weight: inherit;
        margin: inherit;
      }
    }

    input {
      display: none;
    }
  }

  .button--back {
    order: 1;
    margin-top: rem(15px);
  }
}

// tablet
@media (min-width: rem(664px)) {
  .kws-quiz-registration {
    .button--back {
      order: 1;
      margin-top: 0;
      margin-inline-end: rem(20px);
    }
  }
}
</style>

<script>
import { localizeContent } from '@/shared/Utils';
import Dropdown from './registration-form-dropdown.vue';
import Textfield from '../../shared/components/textfield.vue';
import Passwordfield from './registration-form-passwordfield.vue';
import FirstSpiritContentCreatorMixin from '../../shared/mixins/FirstSpiritContentCreatorMixin';
import FirstSpiritImage from './fs-image.vue';
import PostalCodePlaceWrapper from './postal-code-place-wrapper.vue';
import PostalCodePlace from '../../shared/components/postal-code-place.vue';

export default {
  name: 'registration',
  data: () => ({
    formData: null,
    continueAllowed: false,
    PostalCodePlaceWrapper,
  }),
  props: {
    step: Number,
    headline: String,
    result: Object,
    text: String,
    resultText: String,
    img: Object,
    value: Object,
    error: Boolean,
    errorText: String,
  },
  computed: {
    postalCodeUser() {
      return window.KWS?.user?.profile?.address?.zip?.trim() || '';
    },
    cityUser() {
      return window.KWS?.user?.profile?.address?.city || '';
    },
    headlineText() {
      return `${localizeContent(this.step)} <small>${this.translate('lblOf')} ${localizeContent(this.step)}</small>`;
    },
  },
  methods: {
    goBack() {
      this.$emit('go-back');
    },
    handIn() {
      this.$emit('submit');
    },
    setPostalCodeAndCityValue(data) {
      this.formData.city.value = data.placeName;
      this.formData.postalCode.value = data.postalCode;
    },
  },
  watch: {
    formData: {
      handler() {
        this.continueAllowed = !Object.keys(this.formData)
          .filter((key) => {
            if (key === 'postalCodePlace') {
              return key.mandatory && !key.postalCodeValue.length
                && key.mandatory && !key.cityValue;
            }
            return this.formData[key].mandatory && !this.formData[key].value;
          }).length;
        this.$emit('input', this.formData);
      },
      deep: true,
    },
  },
  mixins: [FirstSpiritContentCreatorMixin],
  components: {
    Dropdown,
    Textfield,
    Passwordfield,
    FirstSpiritImage,
    PostalCodePlace,
  },
  created() {
    this.formData = JSON.parse(JSON.stringify(this.value));
  },
};
</script>
